module.exports = __webpack_public_path__ + "img/arrow-back.f751ede3.svg";